import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'
import { TDashboardResponse } from '../Dashboards/types'
import { TDashboardGroupResponse } from 'types/GlobalDashboardGroup'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/dashboard-examples`

export async function getDashboardExamples() {
  return getWithRedirect(URL)
}

export async function addVisit(body: { data: { dashboard_id: string } }) {
  return Axios.post(`${URL}/add-visit`, body, parseAuthenticationHeader())
}

export async function copy(id: string, body: { data: { title: string } }) {
  return Axios.post<{
    data: {
      dashboard: TDashboardResponse
      group: TDashboardGroupResponse
    }
  }>(`${URL}/${id}/copy`, body, parseAuthenticationHeader())
}
